import ReplaceModal from './ReplaceModal';
export default ReplaceModal;